import Preferences from "./preferences";

export { Preferences };
export default Preferences;
